import { Controller } from "@hotwired/stimulus";

import {
  modelOptions,
  prepareNano,
  releaseNano,
  navigateDemo,
} from "../lib/demo_nano_session";
export { modelOptions } from "../lib/demo_nano_session";

export async function browserAvailability() {
  if (!globalThis.LanguageModel) return "unavailable";
  try {
    return await LanguageModel.availability(modelOptions);
  } catch {
    return "unavailable";
  }
}

export default class extends Controller {
  static targets = ["form", "status", "config", "thinking", "thinkingControls", "naturalConfig"];

  connect() {
    this.change({
      target: this.element.querySelector('[name="demo_model"]:checked'),
    });
  }

  async start(event) {
    const form = event.target;
    if (
      this.model !== "browser" ||
      !["conversation", "natural_conversation"].includes(form.querySelector('[name="variant"]').value)
    )
      return;
    event.preventDefault();
    if (this.starting) return;
    this.starting = true;
    // Start setup now; creation of the anonymous draft runs concurrently.
    if (globalThis.LanguageModel)
      prepareNano(JSON.parse(form.querySelector('[name="variant"]').value === "natural_conversation" ? this.naturalConfigTarget.value : this.configTarget.value), { fresh: true });
    const button = form.querySelector('[type="submit"]');
    button.disabled = true;
    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        credentials: "same-origin",
      });
      if (!response.ok) throw new Error("Start failed");
      const html = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      );
      const next = html.querySelector("#checkInContent");
      if (!next?.querySelector(".ft-conversation"))
        throw new Error("Missing conversation");
      navigateDemo(response.url);
      document.querySelector("#checkInContent").replaceWith(next);
      next.querySelector("textarea")?.focus();
    } catch {
      releaseNano();
      this.statusTarget.textContent = "Couldn't start the check-in. Try again.";
      button.disabled = false;
      this.starting = false;
    }
  }

  async change(event) {
    const model = event.target.value;
    this.model = model;
    this.thinkingControlsTarget.hidden = model === "browser";
    const levels = JSON.parse(event.target.dataset.thinkingOptions || "[]");
    const previous = this.thinkingTarget.value;
    this.thinkingTarget.replaceChildren(...levels.map((level) => new Option(level[0].toUpperCase() + level.slice(1), level)));
    if (levels.includes(previous)) this.thinkingTarget.value = previous;
    this.formTargets.forEach((form) => {
      form.querySelector('[name="model"]').value = model === "browser" ? "browser" : "backend";
      if (model !== "browser") form.querySelector('[name="backend_model"]').value = model;
    });
    this.thinkingChanged();
    if (model !== "browser") {
      this.statusTarget.textContent = "";
      return;
    }
    this.statusTarget.textContent = "Checking Gemini Nano availability…";
    const availability = await browserAvailability();
    if (this.model !== "browser") return;
    this.statusTarget.textContent =
      {
        unavailable:
          "Gemini Nano isn't available in this browser or on this device. Use a supported desktop Chrome or choose Backend.",
        downloadable:
          "Gemini Nano needs a first-time download. Starting the conversation begins setup.",
        downloading:
          "Gemini Nano is downloading. You can start an experiment while it finishes.",
        available: "Gemini Nano is ready on this device.",
      }[availability] || "Gemini Nano isn't available here.";
  }

  thinkingChanged() {
    this.formTargets.forEach((form) => {
      const input = form.querySelector('[name="thinking"]');
      input.disabled = this.model === "browser";
      input.value = this.thinkingTarget.value;
    });
  }
}
